import React, { useMemo, useState } from 'react';
import { ImageViewer } from '@stormwater-software/lib-ui';
import { getDownloadUrl } from '../../../utils/api/upload';

type FindingImageProps = {
  lightbox?: boolean;
  sources: any[];
  imageNumber?: any;
  /** heading for the full-screen viewer, e.g. "Finding #53" */
  title?: string;
};

export default function FindingImage({
  lightbox,
  sources,
  imageNumber,
  title,
}: FindingImageProps) {
  // index of the image open in the viewer; null while it is closed
  const [viewerIndex, setViewerIndex] = useState<number | null>(null);

  const images = useMemo(
    () =>
      sources.map((src) => ({
        src: getDownloadUrl(src.guid),
        annotations: src.annotations || [],
      })),
    [sources],
  );

  return (
    <>
      <div
        className='finding-image-holder pointer'
        title={images.length > 1 ? `Click to view all ${images.length} images` : 'Click to enlarge image'}
        onClick={
          lightbox
            ? (e) => {
                e.preventDefault();
                e.stopPropagation();
                setViewerIndex(0);
              }
            : undefined
        }
      >
        <img
          src={images[0].src}
          alt='thumbnail'
          className='finding-thumbnail'
        />

        {imageNumber > 1 && (
          <span className='image-number-text'>{`(+${
            imageNumber - 1
          } IMGs)`}</span>
        )}
      </div>
      {viewerIndex !== null && (
        <ImageViewer
          images={images}
          index={viewerIndex}
          onIndexChange={setViewerIndex}
          onClose={() => setViewerIndex(null)}
          title={title}
        />
      )}
    </>
  );
}

export { FindingImage };
